module.exports = __webpack_public_path__ + "static/media/booklet.b8929fcc.png";